(function () {
  'use strict';

  var MAX_QUANTITY = 5;
  var TOAST_ID = 'lzy-quantity-limit-toast';
  var cartQuantities = new Map();
  var cartReady = false;
  var cartRefresh = null;

  var messages = {
    bg: 'Можете да закупите най-много 5 броя от един продукт.',
    cs: 'U jednoho produktu lze zakoupit maximálně 5 kusů.',
    en: 'You can purchase up to 5 of the same item.',
    hu: 'Egy termékből legfeljebb 5 darab vásárolható.',
    ja: '同一商品は最大5点まで購入できます。',
    lt: 'Vienos prekės galima įsigyti ne daugiau kaip 5 vnt.',
    pl: 'Możesz kupić maksymalnie 5 sztuk jednego produktu.',
    sk: 'Z jedného produktu môžete kúpiť najviac 5 kusov.',
    sl: 'Kupite lahko največ 5 kosov istega izdelka.'
  };

  function language() {
    var value = (document.documentElement.lang || 'en').toLowerCase();
    if (value.indexOf('cz') === 0) return 'cs';
    return messages[value.slice(0, 2)] ? value.slice(0, 2) : 'en';
  }

  function showLimitMessage() {
    var toast = document.getElementById(TOAST_ID);
    if (!toast) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:24px',
        'z-index:2147483647',
        'max-width:min(92vw,460px)',
        'transform:translate(-50%,18px)',
        'padding:12px 16px',
        'border-radius:6px',
        'background:#171717',
        'color:#fff',
        'font:600 14px/1.4 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
        'text-align:center',
        'box-shadow:0 8px 28px rgba(0,0,0,.24)',
        'opacity:0',
        'pointer-events:none',
        'transition:opacity .18s ease,transform .18s ease'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = messages[language()];
    toast.style.opacity = '1';
    toast.style.transform = 'translate(-50%,0)';
    window.clearTimeout(toast._lzyHideTimer);
    toast._lzyHideTimer = window.setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translate(-50%,18px)';
    }, 2600);
  }

  function integerValue(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function isCartQuantityInput(input) {
    if (!input || input.tagName !== 'INPUT') return false;
    if (input.name === 'updates[]' || input.name.indexOf('updates[') === 0) return true;
    return Boolean(input.closest('cart-items, cart-drawer-items, [data-cart-items], [data-cart-drawer], .cart-drawer, .cart-items'));
  }

  function isQuantityInput(input) {
    if (!input || input.tagName !== 'INPUT') return false;
    if (input.name === 'quantity' || input.name === 'updates[]' || input.name.indexOf('updates[') === 0) return true;
    if (input.matches('.quantity__input, [data-quantity-input], input[data-quantity-selector]')) return true;
    return Boolean(input.closest('quantity-input, .quantity-selector, [data-quantity-selector]')) && input.type === 'number';
  }

  function configureInput(input) {
    if (!isQuantityInput(input)) return;
    input.setAttribute('step', '1');
    input.setAttribute('max', String(MAX_QUANTITY));
    if (isCartQuantityInput(input)) {
      input.setAttribute('min', '0');
    } else {
      input.setAttribute('min', '1');
    }
  }

  function clampInput(input, notify) {
    if (!isQuantityInput(input)) return false;
    configureInput(input);
    var minimum = isCartQuantityInput(input) ? 0 : 1;
    var value = integerValue(input.value, minimum);
    var clamped = Math.max(minimum, Math.min(MAX_QUANTITY, value));
    if (String(clamped) !== String(input.value)) {
      input.value = String(clamped);
      input.setAttribute('value', String(clamped));
      if (notify && value > MAX_QUANTITY) showLimitMessage();
      return true;
    }
    return false;
  }

  function configureQuantities(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.tagName === 'INPUT') configureInput(root);
    scope.querySelectorAll('input[name="quantity"], input[name="updates[]"], input[name^="updates["], .quantity__input, [data-quantity-input], input[data-quantity-selector], quantity-input input[type="number"], .quantity-selector input[type="number"], [data-quantity-selector] input[type="number"]').forEach(configureInput);
  }

  function quantityInputForButton(button) {
    var scope = button.closest('quantity-input, .quantity, .quantity-selector, [data-quantity-selector], [data-quantity], cart-items, cart-drawer-items');
    if (!scope) scope = button.parentElement;
    if (!scope) return null;
    return scope.querySelector('input[name="quantity"], input[name="updates[]"], input[name^="updates["], .quantity__input, [data-quantity-input], input[type="number"]');
  }

  function isPlusButton(button) {
    if (!button) return false;
    if (button.matches('[name="plus"], [data-quantity-plus], [data-plus], .quantity-plus, .quantity__button--plus')) return true;
    var label = (button.getAttribute('aria-label') || button.getAttribute('title') || '').toLowerCase();
    if (/increase|increment|plus|add|zvýšit|přidat|увелич|dodaj|zwiększ|növel|増や|pridaj|padid|poveč/.test(label)) return true;
    return button.textContent.trim() === '+' && Boolean(quantityInputForButton(button));
  }

  function variantIdFromForm(form) {
    var input = form.querySelector('[name="id"]:not([disabled])');
    return input ? String(input.value || '') : '';
  }

  function requestedQuantityFromForm(form) {
    var input = form.querySelector('input[name="quantity"]');
    if (!input) return 1;
    clampInput(input, true);
    return integerValue(input.value, 1);
  }

  function setRequestedQuantity(form, value) {
    var input = form.querySelector('input[name="quantity"]');
    if (input) {
      input.value = String(value);
      input.setAttribute('value', String(value));
    }
  }

  function refreshCartQuantities() {
    if (cartRefresh) return cartRefresh;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    cartRefresh = window.fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function (cart) {
      var next = new Map();
      (cart.items || []).forEach(function (item) {
        var key = String(item.variant_id || item.id || '');
        next.set(key, (next.get(key) || 0) + integerValue(item.quantity, 0));
      });
      cartQuantities = next;
      cartReady = true;
    }).catch(function () {
      cartReady = false;
    }).finally(function () {
      cartRefresh = null;
    });
    return cartRefresh;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button, [role="button"]');
    if (!button || !isPlusButton(button)) return;
    var input = quantityInputForButton(button);
    if (!input || !isQuantityInput(input)) return;
    configureInput(input);
    if (integerValue(input.value, 1) >= MAX_QUANTITY) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = String(MAX_QUANTITY);
      showLimitMessage();
    }
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!isQuantityInput(input)) return;
    configureInput(input);
    var value = integerValue(input.value, 1);
    if (value > MAX_QUANTITY) clampInput(input, true);
  }, true);

  document.addEventListener('change', function (event) {
    if (isQuantityInput(event.target)) clampInput(event.target, true);
  }, true);

  document.addEventListener('blur', function (event) {
    if (isQuantityInput(event.target)) clampInput(event.target, true);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var variantId = variantIdFromForm(form);
    if (!variantId) return;
    var requested = requestedQuantityFromForm(form);
    var inCart = cartQuantities.get(variantId) || 0;
    if (cartReady && inCart >= MAX_QUANTITY) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showLimitMessage();
      return;
    }
    if (cartReady && inCart + requested > MAX_QUANTITY) {
      requested = MAX_QUANTITY - inCart;
      if (requested <= 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showLimitMessage();
        return;
      }
      setRequestedQuantity(form, requested);
      showLimitMessage();
    }
    cartQuantities.set(variantId, Math.min(MAX_QUANTITY, inCart + requested));
    window.setTimeout(refreshCartQuantities, 900);
  }, true);

  ['cart:updated', 'cart:refresh', 'cart-drawer:updated', 'product:added', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, refreshCartQuantities);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) configureQuantities(node);
      });
    });
  });

  function start() {
    configureQuantities(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    refreshCartQuantities();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
